/** Shared class label palette — kept outside shift module to avoid circular deps. */
export const CLASS_THEME_COLORS = [
  '#10b981', // emerald
  '#0ea5e9', // sky
  '#f59e0b', // amber
  '#8b5cf6', // violet
  '#f43f5e', // rose
  '#64748b', // slate
  '#14b8a6', // teal
  '#3b82f6', // blue
  '#eab308', // yellow
  '#a855f7', // purple
  '#ec4899', // pink
  '#ef4444', // red
  '#22c55e', // green
  '#06b6d4', // cyan
  '#f97316', // orange
  '#6366f1', // indigo
  '#84cc16', // lime
  '#d946ef', // fuchsia
  '#0f766e', // teal-dark
  '#1d4ed8', // blue-dark
  '#b45309', // amber-dark
  '#7c3aed', // violet-dark
  '#be123c', // rose-dark
  '#334155', // slate-dark
] as const;
